import { useState, useEffect } from 'preact/hooks';
import type { Team } from '../types';
import { authService } from '../services/auth/authService';

export function useTeams() {
  const [teams, setTeams] = useState<Team[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadTeams = async () => {
    try {
      setLoading(true);
      setError(null);

      // Get token from auth service (works for both local and Cognito modes)
      const token = await authService.getToken();
      const headers: Record<string, string> = {};
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }

      const response = await fetch(`${import.meta.env.VITE_API_URL}/teams`, { headers });

      if (!response.ok) {
        if (response.status === 404) {
          setTeams([]);
          return;
        }
        throw new Error('Failed to load teams');
      }

      const data = await response.json();
      setTeams(data.teams || []);
    } catch (err) {
      console.error('Error loading teams:', err);
      setError(err instanceof Error ? err.message : 'Failed to load teams');
      setTeams([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadTeams();
  }, []);

  return { teams, loading, error, reload: loadTeams };
}
